// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/instrument_editor/templates/envelope.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_attrs0 = {
        "class": "envelope-editor"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("91c9e6"),
    marko_node0 = marko_createElement("div", {
        "class": "waveform"
      }, "1", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("canvas", {
          "class": "waveform-canvas"
        }, null, null, 0),
    marko_attrs1 = {
        "class": "envelope-controls"
      },
    marko_attrs2 = {
        "class": "control-panel"
      },
    marko_attrs3 = {
        "class": "control-group"
      },
    marko_attrs4 = {
        "class": "control-group"
      },
    marko_attrs5 = {
        "class": "control-group"
      },
    marko_attrs6 = {
        "class": "control"
      },
    marko_node1 = marko_createElement("label", {
        "for": "on"
      }, "7", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("On"),
    marko_attrs7 = {
        "class": "control"
      },
    marko_attrs8 = {
        "class": "control range"
      },
    marko_node2 = marko_createElement("label", {
        "for": "sustain"
      }, "11", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Sustain"),
    marko_node3 = marko_createElement("label", {
        "for": "sustain-point"
      }, "14", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Point"),
    marko_attrs9 = {
        "class": "control"
      },
    marko_attrs10 = {
        "class": "control range"
      },
    marko_attrs11 = {
        "class": "control range"
      },
    marko_node4 = marko_createElement("label", {
        "for": "loop"
      }, "18", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Loop"),
    marko_node5 = marko_createElement("label", {
        "for": "loop-start-point"
      }, "21", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Start"),
    marko_node6 = marko_createElement("label", {
        "for": "loop-end-point"
      }, "24", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("End"),
    marko_node7 = marko_createElement("div", {
        "class": "control-group"
      }, "26", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "control"
        }, null, null, 1)
        .e("button", {
            id: "create-envelope"
          }, null, null, 1)
          .t("Create")
      .t(" ");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.n(marko_node0, component);

  out.be("div", marko_attrs1, "3", component);

  out.be("div", marko_attrs2, "4", component);

  if (data.envelope != null) {
    out.e("div", marko_attrs3, "5", component, 1)
      .e("div", marko_attrs6, "6", component, 2)
        .n(marko_node1, component)
        .e("input", {
            type: "checkbox",
            id: "on",
            checked: (data.envelope.type & 1) !== 0
          }, "8", component, 0);

    out.e("div", marko_attrs4, "9", component, 2)
      .e("div", marko_attrs7, "10", component, 2)
        .n(marko_node2, component)
        .e("input", {
            type: "checkbox",
            id: "sustain",
            checked: (data.envelope.type & 2) !== 0
          }, "12", component, 0)
      .e("div", marko_attrs8, "13", component, 2)
        .n(marko_node3, component)
        .e("input", {
            id: "sustain-point",
            "class": "range-input",
            value: "" + data.envelope.sustain,
            type: "text"
          }, "15", component, 0);

    out.e("div", marko_attrs5, "16", component, 3)
      .e("div", marko_attrs9, "17", component, 2)
        .n(marko_node4, component)
        .e("input", {
            type: "checkbox",
            id: "loop",
            checked: (data.envelope.type & 4) !== 0
          }, "19", component, 0)
      .e("div", marko_attrs10, "20", component, 2)
        .n(marko_node5, component)
        .e("input", {
            id: "loop-start-point",
            "class": "range-input",
            value: "" + data.envelope.loopstart,
            type: "text"
          }, "22", component, 0)
      .e("div", marko_attrs11, "23", component, 2)
        .n(marko_node6, component)
        .e("input", {
            id: "loop-end-point",
            "class": "range-input",
            value: "" + data.envelope.loopend,
            type: "text"
          }, "25", component, 0);
  } else {
    out.n(marko_node7, component);
  }

  out.ee();

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
